import { createAction, props } from "@ngrx/store";
import { AppNameState } from "./state";

export const saveAppName = createAction('[Login] Save App Name ', props<{ appname : AppNameState }>());
export const deleteAppName = createAction('[Logout] Delete App Name');
